import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import MapBlocksToComponents from "Helpers/BlockHelper";
import {MultipleAnimation, PageTransition} from "Animations";
import {useDispatch, useSelector} from "react-redux";
import {listPageActions} from "../../framework/redux/actions/index";
import {
    HitsCategoriesWrapper,
    HitsCountWrapper,
    HitsWrapper,
    NoHitsTextParagraph,
    SearchWrapper,
} from "../../Components/Search/hits/StyledSearch";
import {Paragraph} from "BaseComponents/Text";
import {ButtonText, PrimaryButton} from "BaseComponents/Button";
import {SearchHitWithCategory} from "../../Components/Search/hits/SearchHitWithCategory";
import {SearchCategory} from "../../Components/Search/hits/SearchCategory";

let ListPageWithChildren = ({
                                Heading,
                                Breadcrumbs,
                                ShowMoreText,
                                ElementArea,
                                ShowPriorityItem,
                                currentPageId,
                                CurrentCulture,
                                NoHitsText,
                                AllCategoriesText
                            }) => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state.listpage);

    const [searchHits, setSearchHits] = useState(
        useSelector((state) => state.items)
    );
    const [showLoadMore, setShowLoadMore] = useState(true);
    const [page, setPage] = useState(1);
    const [allCategoriesInner, setAllCategories] = useState(
        useSelector((state) => state.allCategories)
    );
    const [searchHitsText, setSearchHitsText] = useState(
        useSelector((state) => state.searchHitsText)
    );
    const [filterCategory, setFilterCategory] = useState(
        useSelector((state) => state.categories ?? [])
    );

    const [loadingInner, setLoading] = useState(
        useSelector((state) => state.loading)
    );
    const [loadingAllCategoriesInner, setLoadingAllCategories] = useState(
        useSelector((state) => state.loadingAllCategories)
    );

    useEffect(() => {
        if (state.initParams) {
            setLoading(true);
            dispatch(
                listPageActions.getItems(
                    currentPageId,
                    page,
                    CurrentCulture,
                    state.categories,
                    true
                )
            );
        }
    }, [state.initParams]);

    useEffect(() => {
        //TODO: filtrera
        setAllCategories(state.allCategories);
        setLoading(state.loading);
        setLoadingAllCategories(state.loadingAllCategories);
        setShowLoadMore(state.loadMore);
        setSearchHits(state.items);
        setSearchHitsText(state.searchHitsText);
    }, [
        state.allCategories,
        state.loading,
        state.loadingAllCategories,
        state.loadMore,
        state.items,
        state.searchHitsText,
    ]);

    useEffect(() => {
        if (!allCategoriesInner?.length && !loadingAllCategoriesInner) {
            setLoadingAllCategories(true);
            dispatch(listPageActions.getAllCategories(currentPageId, CurrentCulture));
        }
    }, []);

    const getMore = (e, newPage) => {
        e.preventDefault();
        setLoading(true);
        dispatch(
            listPageActions.getItems(
                currentPageId,
                newPage,
                CurrentCulture,
                filterCategory
            )
        );
    };

    useEffect(() => {
        setPage(1);
        if (!loadingInner) {
            setLoading(true);
            dispatch(
                listPageActions.getItems(
                    currentPageId,
                    1,
                    CurrentCulture,
                    filterCategory,
                    true
                )
            );
        }
    }, [filterCategory]);

    return (
        <>
            {/*<BreadcrumbsComp Items={Breadcrumbs} />*/}
            <PageTransition>
                {ElementArea?.length > 0 && MapBlocksToComponents(ElementArea)}
            </PageTransition>
            <SearchWrapper>
                <HitsCountWrapper>
                    <HitsCategoriesWrapper>
                        {!loadingAllCategoriesInner && allCategoriesInner?.length && (
                            <SearchCategory                               
                                categories={allCategoriesInner ?? []}
                                defaultValue={
                                    typeof state.categories == "string" &&
                                    state.categories?.length
                                        ? {value: state.categories, label: state.categories}
                                        : undefined
                                }
                                allCategoriesText={AllCategoriesText}
                                onCategoryChange={(value) => {
                                    setFilterCategory(value ? [value] : []);
                                }}
                            />
                        )}
                    </HitsCategoriesWrapper>
                    <Paragraph
                        margin={"10px 0"}
                        fontSize={"16px"}
                        large
                        dangerouslySetInnerHTML={{__html: searchHitsText}}
                    ></Paragraph>
                </HitsCountWrapper>
                <HitsWrapper flex showPriority={ShowPriorityItem}>
                    {searchHits !== undefined && (
                        <MultipleAnimation
                            items={searchHits}
                            loading={loadingInner}
                            mass={15}
                            tension={2000}
                            friction={200}
                        >
                            <SearchHitWithCategory showPriority={ShowPriorityItem} flex/>
                        </MultipleAnimation>
                    )}
                    {!loadingInner && searchHits?.length == 0 && (
                        <NoHitsTextParagraph>{NoHitsText}</NoHitsTextParagraph>
                    )}
                </HitsWrapper>
                {showLoadMore && (
                    <PrimaryButton
                        disabled={loadingInner}                       
                        justifycontent="center"
                        display="flex"
                        margin="0 auto 3rem auto"
                        onClick={(e) => {
                            setPage(page + 1);
                            getMore(e, page + 1);
                        }}
                        href={'#'}
                    >
                        <ButtonText heading={Heading}>{ShowMoreText}</ButtonText>
                    </PrimaryButton>
                )}
            </SearchWrapper>
        </>
    );
};

ListPageWithChildren.propTypes = {
    Heading: PropTypes.string,
};

export default ListPageWithChildren;
